/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxPerStudentSetupTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_PER_STUDENT_SETUP_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AutoTestMaxPerStudentSetupTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxPerStudentSetupTimeSettingParser.decode(input).map(res => new AutoTestMaxPerStudentSetupTimeSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxPerStudentSetupTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxPerStudentSetupTimeSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxPerStudentSetupTimeSettingParser.schema();
    }
}
